import { useLanguage } from '../lib/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <Globe size={16} className="text-[#71717A]" />
      <div className="flex rounded-sm overflow-hidden border border-[#E4E4E7]">
        <button
          onClick={() => setLanguage('de')}
          className={`px-3 py-1.5 text-xs font-medium uppercase tracking-wide transition-colors ${
            language === 'de'
              ? 'bg-[#D4B982] text-[#0A0A0A]'
              : 'bg-white text-[#71717A] hover:bg-[#F4F4F5]'
          }`}
          data-testid="lang-de-btn"
        >
          DE
        </button>
        <button
          onClick={() => setLanguage('en')}
          className={`px-3 py-1.5 text-xs font-medium uppercase tracking-wide transition-colors ${
            language === 'en'
              ? 'bg-[#D4B982] text-[#0A0A0A]'
              : 'bg-white text-[#71717A] hover:bg-[#F4F4F5]'
          }`}
          data-testid="lang-en-btn"
        >
          EN
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
